// extracted by mini-css-extract-plugin
module.exports = {"viewport":"_9BfszAAs1lUx4fNjCHn9lw=="};